import { StudyEntityType } from '../study-entity-type.js';
import { z } from 'zod';
import { baseStudyEntityValidationSchema } from '../validation/index.js';
import { IllegalArgumentError } from 'faro-common-model';
import { uuidish } from '../../utils/uuidish.js';
/**
 * Compose a `zod` validation schema that validates the `VeevaCaseReportFormMapping` and `StudyEntity` fields.
 */
export const veevaCaseReportFormMappingValidationSchema = z.object({
    ...baseStudyEntityValidationSchema.shape,
    entityType: z.literal(StudyEntityType.VeevaFormMapping).default(StudyEntityType.VeevaFormMapping),
    scheduleOfActivitiesId: uuidish.describe('scheduleOfActivitiesId is required'),
    activityId: uuidish.describe('activityId is required'),
    veevaCaseReportFormId: z.string().describe('veevaCaseReportFormId is required'),
});
export function toVeevaCaseReportFormMapping(input) {
    const result = veevaCaseReportFormMappingValidationSchema.safeParse(input);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid VeevaCaseReportFormMapping object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=veeva-case-report-form-mapping.js.map